import React, { useContext, useEffect, useState } from "react"
import styles from "./ContentConfirmation.module.css"
import { FormTitle } from "../../../Common/FormTitle"
import { NextButton } from "../../../Common/CtaButton/NextButton"
import { InputInformation } from "./InputInformation"
import { StepContext } from "../../StepContainer"
import { fetchRegistration } from "../../../../app/api/registrationApi"
import { sendSlackNotification } from "../../../../SlackNotification"
import { RESISTRATION_FAILED_TEMPLATE } from "../../../../slackMessageTemplate"

export const ContentConfirmation = () => {
    const [isFormValid, setIsFormValid] = useState(false)
    const [termsChecked, setTermsChecked] = useState(false)
    const [privacyChecked, setPrivacyChecked] = useState(false)
    const [mailMagazineChecked, setMailMagazineChecked] = useState(1)
    const { formState, displayState, webhook } = useContext(StepContext)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [submitError, setSubmitError] = useState("")

    useEffect(() => {
        setIsFormValid(termsChecked && privacyChecked)
    }, [termsChecked, privacyChecked])

    const handleSubmit = async () => {
        if (isSubmitting) return

        try {
            setIsSubmitting(true)

            await fetchRegistration(formState)
        } catch (error) {
            const errorMessage =
                "エラーが発生し登録に失敗しました。担当者からお電話させていただきます。"
            setSubmitError(errorMessage)

            const userValues = `
現在の状況: ${displayState.situation}
経験年数: ${displayState.experienceYears}
性別: ${displayState.sex}
誕生日: ${displayState.birthday}
住所: ${displayState.prefectureCity}
名前: ${displayState.name}
名前(カナ): ${displayState.nameKana}
電話番号: ${displayState.tel}
LINE ID: ${displayState.lineId}
email: ${displayState.email}
パスワード: ${displayState.password ? "********" : ""}
直近の会社名: ${displayState.companyName}
料理ジャンル: ${displayState.genre}
職種: ${displayState.occupation}
雇用形態: ${displayState.employment}
仕事内容: ${displayState.detailedJobDetails}
勤務開始日: ${displayState.workStartDate}
勤務終了日: ${displayState.workEndDate}`

            sendSlackNotification(
                `${error.message || errorMessage}\n` +
                    `${RESISTRATION_FAILED_TEMPLATE.MENSION1} ${RESISTRATION_FAILED_TEMPLATE.MENSION2} ${RESISTRATION_FAILED_TEMPLATE.MENSION3}\n` +
                    `${RESISTRATION_FAILED_TEMPLATE.TEXT}\n` +
                    "ユーザー情報: " +
                    "```" +
                    `${userValues || "取得できません"}\n` +
                    "```",
                webhook
            )

            throw error
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText="最後に内容を確認して、完了しましょう！"
                        dataViewLabel="EF_最後の内容_pv"
                        dataClickLabel="EF_最後の内容_戻る"
                    />
                </div>
                <div className={styles.approvalWrapper}>
                    <p className={styles.textContents}>
                        <span className={styles.policyText}>
                            フーズラボの
                            <a
                                className={styles.policyUrl}
                                href="https://cuolega.co.jp/terms/"
                                target="_blank"
                            >
                                利用規約
                            </a>
                            に同意いただけますか？
                        </span>
                    </p>
                    <div className={styles.checkContent}>
                        <input
                            type="checkbox"
                            id="checkbox1"
                            className={styles.checkboxInput}
                            checked={termsChecked}
                            onChange={e => setTermsChecked(e.target.checked)}
                        />
                        <label
                            htmlFor="checkbox1"
                            className={styles.checkboxLabel}
                        >
                            利用規約に同意する
                        </label>
                        <input
                            type="checkbox"
                            id="checkbox2"
                            className={styles.checkboxInput}
                            checked={privacyChecked}
                            onChange={e => setPrivacyChecked(e.target.checked)}
                        />
                        <label
                            htmlFor="checkbox2"
                            className={styles.checkboxLabel}
                        >
                            個人情報の取り扱い
                            <br />
                            (利用規約第4条、第5条)に同意する
                        </label>
                    </div>
                </div>
                <div>
                    {submitError && (
                        <p className={styles.errorMessages}>{submitError}</p>
                    )}
                    <NextButton
                        formKey={"mailMagazine"}
                        formValue={mailMagazineChecked}
                        isDisabled={!isFormValid || isSubmitting}
                        confirmation={"完了する"}
                        onSubmit={handleSubmit}
                        dataClickLabel="EF_最後の内容_完了する"
                        isLoading={isSubmitting}
                    />
                    <p className={styles.descriptionText}>
                        入力した情報は応募先の企業以外全て非公開です
                    </p>
                </div>
                <div className={styles.approvalWrapper}>
                    <div className={styles.textContents}>
                        <p className={styles.emailText}>メールマガジン配信</p>
                        <p className={styles.explanationText}>
                            今月の注目求人や転職ノウハウなどお役立ち情報をお届けします。
                        </p>
                    </div>
                    <div className={styles.checkContent}>
                        <input
                            type="checkbox"
                            id="checkbox3"
                            className={styles.checkboxInput}
                            checked={mailMagazineChecked === 1}
                            onChange={e =>
                                setMailMagazineChecked(e.target.checked ? 1 : 0)
                            }
                        />
                        <label
                            htmlFor="checkbox3"
                            className={styles.checkboxLabel}
                            data-click-label="EF_内容の確認_メールマガジン配信希望する"
                        >
                            希望する
                        </label>
                    </div>
                </div>

                <InputInformation />
            </div>
        </div>
    )
}
